import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import "./DragDropFile.css";
import { notify } from "react-notify-toast";

const fileTypes = ["PDF", "JPEG", "JPG", "PNG"];

function DragDropFile({
  title,
  fileName,
  link,
  fileType,
  file,
  qualificationType,
  handleChangeFile
}) {
  const [fileNameUpload, setFileNameUpload] = useState(fileName || file?.name || "")

  const handleChange = async (fileUploaded) => {

    setFileNameUpload(fileUploaded.name.replace(/[^\w.]/gi, "").replace(/  +/g, ""));
    await handleChangeFile(fileUploaded, fileType, qualificationType)
  }

  const handleTypeError = (error) => {
    notify.show("You are uploading the wrong file type")
  }

  return (
    <div className="file-upload mb-3">
      <FileUploader
        handleChange={handleChange}
        name="file"
        types={fileTypes}
        onTypeError={handleTypeError}
        label={title ? title : "Upload or drop a qualification file right here"}
      />
      { fileNameUpload
        ? link
          ? <>
              <b>File uploaded: </b>
              <a href={`/NavigateToFileViewer?fileurl=${link}`} target="_blank">
                {fileNameUpload}
              </a>
            </>
          : <p className="mb-3">
              <b>File uploaded: </b>
              {fileNameUpload}
            </p>
        : "" }
    </div>
  );
}

export default DragDropFile;